import { PUBLIC_PROFILE_ACTION, IPublicProfileActionService } from "../IPublicProfileActionService";
import { Injectable } from "@angular/core";
import { CubiqWorker } from "../../worker/CubiqWorker";
import {
  PRIMITIVE,
  ServiceMessageBrokerFactory,
  ServiceMessageBroker,
} from "shared/provider-webworker";
import { ProfilePromiseActionService } from "./ProfilePromiseActionService";
import * as CubiqTS from "shared/cubiq-model-multi-asset";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

import { ProfileSettingKeys } from "../../model/core/ProfileSettingKeys";
import { ActiveUser, ActiveUserProfilePromiseService } from "shared/auth-services";

@Injectable()
export class PublicProfilePrimaryActionService implements IPublicProfileActionService {
  private broker: ServiceMessageBroker;

  /** User code for current user session */
  private userCd: string;

  constructor(
    private worker: CubiqWorker,
    private factory: ServiceMessageBrokerFactory,
    private userProfileService: ProfilePromiseActionService,
    private activeUserService: ActiveUserProfilePromiseService,
  ) {
    this.broker = this.factory.createMessageBroker(PUBLIC_PROFILE_ACTION, true, true);
    this.broker.registerMethod(
      "savePublicProfile",
      [PRIMITIVE, PRIMITIVE, PRIMITIVE],
      this.savePublicProfile.bind(this),
      PRIMITIVE,
    );
    this.activeUserService.getActiveUserData().then((activeUser: ActiveUser) => {
      this.userCd = activeUser.userCode;
    });
  }

  savePublicProfile(
    publicProfileName: string,
    layout: string,
    overwriteExisting: boolean = false,
  ): Promise<CubiqTS.ErrorsImpl | null> {
    return new Promise<CubiqTS.ErrorsImpl | null>((resolve, reject) => {
      let req: CubiqTS.PublicProfileUpdateRequestImpl =
        new CubiqTS.PublicProfileUpdateRequestImpl();
      let publicProfileSettingList: Array<CubiqTS.ProfileSetting> = [];
      this.userProfileService.getProfileSettings().then((settings) => {
        if (settings) {
          publicProfileSettingList = this.createProfileSettingsList(settings, layout);
          req.name = publicProfileName;
          req.overwriteExisting = overwriteExisting;
          req.settings = publicProfileSettingList;
          this.worker.postServiceRequest(req).then(
            (payload: any) => {
              resolve(payload);
            },
            (error: any) => {
              reject(error);
            },
          );
        }
      });
    });
  }

  private createProfileSettingsList(
    profileObject: any = null,
    layout,
  ): Array<CubiqTS.ProfileSetting> {
    let publicProfileSettingList: Array<CubiqTS.ProfileSetting> = [];
    Object.keys(profileObject).forEach((p) => {
      if (p !== ProfileSettingKeys.userProfileGLContent) {
        let setting: CubiqTS.ProfileSettingImpl = new CubiqTS.ProfileSettingImpl();
        setting.profileSettingKey = p;
        setting.profileSettingValue = profileObject[p];
        publicProfileSettingList.push(setting);
      }
    });
    let layoutSetting: CubiqTS.ProfileSettingImpl = new CubiqTS.ProfileSettingImpl();
    layoutSetting.profileSettingKey = ProfileSettingKeys.userProfileGLContent;
    layoutSetting.profileSettingValue = layout;
    publicProfileSettingList.push(layoutSetting);
    return publicProfileSettingList;
  }

  /**
   * Switch the profile for the current user to the specified profile. This should result in the
   * user session being immediately terminated on success
   * @param profile
   * @returns
   */
  public switchProfile(profile: CubiqTS.PlatformProfileImpl): Promise<void> {
    return new Promise((res, rej) => {
      const request = new CubiqTS.UserProfileChangeRequestImpl();
      if (profile) {
        request.profileName = profile.profileName;
        request.isUserProfileFg = profile.isUserProfileFg;
      } else {
        request.profileName = null;
        request.isUserProfileFg = false;
      }
      request.userCd = this.userCd;

      this.worker.postServiceRequest(request).then((value) => {
        if (value instanceof CubiqTS.ErrorsImpl) {
          logger.out.info(`switchProfile Error result ${value}`);
          rej(value);
        } else {
          res();
        }
      });
    });
  }
}
